import { ChangeDetectionStrategy, Component, OnInit, EventEmitter, Input, Output, ChangeDetectorRef } from '@angular/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { BehaviorSubject } from 'rxjs';
import { CommonPdfPopupComponent } from '../common-pdf-popup/common-pdf-popup.component';
import { PdfData, PdfType } from '@fitness-force/models';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'number-prefix',
  templateUrl: './number-prefix.component.html',
  providers: [DialogService],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, TooltipModule, TranslateModule]
})
export class NumberPrefixComponent implements OnInit {
  @Input() columnData  = new BehaviorSubject(null);
  @Input() additionData = new BehaviorSubject(null) 
  @Output() onAction = new EventEmitter();

  refServiceModal?: DynamicDialogRef;

  constructor(private dialogService: DialogService, private cd: ChangeDetectorRef) { }

  ngOnInit(): void {
  }

  OpenPdf(pdfType:PdfType, columnData:any, additionData:any, numberPrefix:string)
  {
    let data:PdfData ={} as PdfData;
    switch (pdfType) {
      case PdfType.Invoice:
        {
          if(columnData['invoices'] && columnData['invoices'].length > 0)
          {
            let invoiceData= columnData['invoices'].find((i: { number_prefix: string; }) => i.number_prefix == numberPrefix)!;
            data = {
              type: PdfType.Invoice,
              primaryId: invoiceData.id,
              secondaryId: 0,
              numberPrefix: invoiceData.number_prefix,
              status: invoiceData.status,
              clientId: invoiceData.client_id,
              tenantId: invoiceData.tenant_id
            }
          }
          else{
            data = {
              type: PdfType.Invoice,
              primaryId: columnData[additionData.id],
              secondaryId: 0,
              numberPrefix: columnData[additionData.fetch_key],
              status: columnData["status"],
              clientId: columnData["client_id"],
              tenantId: columnData["tenant_id"]
            }
          }
        }
        break;
      case PdfType.Payment:
        {
          data = {
            type: PdfType.Payment,
            primaryId: columnData[additionData.id],
            secondaryId: 0,
            numberPrefix: columnData[additionData.fetch_key],
            status: columnData["status"],
            clientId: columnData["client_id"],
            tenantId: columnData["collected_at_tenant_id"]
          }
        }
        break;
      case PdfType.SalesReturn:
        {
          data = {
            type: PdfType.SalesReturn,
            primaryId: columnData[additionData.id],
            secondaryId: columnData["invoice_id"],
            numberPrefix: columnData[additionData.fetch_key],
            status: columnData["is_void"] == true ? "void" : "",
            clientId: columnData["client_id"],
            tenantId: columnData["tenant_id"]
          }
        }
        break;
      case PdfType.Refund:
        {
          data = {
            type: PdfType.Refund,
            primaryId: columnData[additionData.id],
            secondaryId: 0,
            numberPrefix: columnData[additionData.fetch_key],
            status: columnData["refund_status"],
            clientId: columnData["client_id"],
            tenantId: columnData["tenant_id"]
          }
        }
        break;
    }

    this.refServiceModal = this.dialogService.open(CommonPdfPopupComponent, {
      showHeader: false,
      width: '70%',
      contentStyle: { 'max-height': '500px', overflow: 'auto', 'padding': 0 },
      baseZIndex: 10000,
      data,
    });

    this.refServiceModal.onClose.subscribe((res: PdfData) => {
      if(res && res != null)
      {
        if(res.type == PdfType.SalesReturn) columnData["is_void"] = res.status =='void' ? true : false;
        else columnData["status"] = res.status;
        this.onAction.emit({action:'updatedata',columnData:columnData});
      }
      this.cd.detectChanges();
    });
  }

  get getPdfType()
  {
    return PdfType;
  }
}